import { render, staticRenderFns } from "./syInstitutionalFramework.vue?vue&type=template&id=52e46078&scoped=true&"
import script from "./syInstitutionalFramework.vue?vue&type=script&lang=js&"
export * from "./syInstitutionalFramework.vue?vue&type=script&lang=js&"
import style0 from "./syInstitutionalFramework.vue?vue&type=style&index=0&id=52e46078&prod&lang=less&"
import style1 from "./syInstitutionalFramework.vue?vue&type=style&index=1&id=52e46078&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e46078",
  null
  
)

export default component.exports